import React from 'react';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';

function Canceled({ data }) {
  const { profileLoginUrl } = data;

  return (
    <div className="mn_emailUnsubscribe">
      <ContentWrap className="mn_unsubscribeCanceled">
        <div className="mn_alertInfo mn_warning">No changes were made to your preferences.</div>
        <p>You may log in at any time to manage your <a href={profileLoginUrl}>Communication Preferences</a>.</p>
      </ContentWrap>
    </div>
  );
}

export default Canceled;
